import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { historyShape, dateRangeShape } from '../../utils/propTypes';
import { connect } from 'react-redux';
import { toastIfError } from '../../utils/toast';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import {
    getIsMerchantsLoaded,
    getMerchantIdsString
} from '../Merchants/merchantsEntity';
import { getSelectedMerchantIdsString } from '../MerchantSelector/merchantSelectorViewState';
import {
    EmvioCard,
    EmvioRow,
    EmvioTable
} from '@nexio/emvio-util-ui';
import { getMerchantsMapper } from '../Merchants/merchantsEntity';
import {
    onUnmount,
    getColumnsSettings,
    updateColumnsSettings
} from './tableActions';
import {
    getColumnsByUniqueTableName,
    getColumnsErrorMessageByUniqueTableName,
    getIsColumnsLoadedByUniqueTableName,
    getIsColumnsLoadingByUniqueTableName,
    getSortsByUniqueTableName,
    getDateRange
} from './tableEntity';
import mixpanel from '../../utils/mixpanel';
import { withRouter } from 'react-router';
import { getCSV } from '../CSVs/csvActions';
import { getCsvData, getIsCsvLoading, getCsvErrorMessage } from '../CSVs/csvEntity';
import moment from 'moment-timezone';
import {
    debounce,
    get,
    find,
    map,
    noop
} from 'lodash';
import './Table.scss';
import { updateDateRange } from './tableActions';
import { preserveQueryParams } from './utils/queryParamsUtils';
import classNames from 'classnames';
import { getCustomAccess } from '../Self/selfEntity';
import { doesRoleHaveAccessToFeature } from '../../utils/customRole';
import config from '../../config/config';

export class Table extends Component {
    static propTypes = {
        allMerchantIdsString: PropTypes.string,
        bulkActions: PropTypes.arrayOf(PropTypes.shape({
            ButtonLabel: PropTypes.string,
            onClick: PropTypes.func
        })),
        className: PropTypes.string,
        clickShouldExpandRow: PropTypes.bool,
        columns: PropTypes.array,
        columnsError: PropTypes.string,
        columnsToNotClick: PropTypes.arrayOf(PropTypes.string),
        count: PropTypes.number,
        countSelector: PropTypes.func,
        csvData: PropTypes.array,
        csvError: PropTypes.string,
        csvLoading: PropTypes.bool,
        data: PropTypes.array,
        dataSelector: PropTypes.func.isRequired,
        dateKey: PropTypes.string,
        defaultColumnsAndProps: PropTypes.array.isRequired,
        defaultFiltered: PropTypes.array,
        defaultPageSize: PropTypes.number,
        defaultSorted: PropTypes.array,
        error: PropTypes.string,
        errorMessageSelector: PropTypes.func.isRequired,
        exportButtonMessage: PropTypes.string,
        fetchData: PropTypes.func.isRequired,
        fetchUrl: PropTypes.string.isRequired,
        filterable: PropTypes.bool,
        getTableState: PropTypes.func,
        globalDateRange: dateRangeShape,
        hasMore: PropTypes.bool,
        hasMoreSelector: PropTypes.func,
        hasNoCount: PropTypes.bool,
        HeaderComponent: PropTypes.func,
        history: historyShape,
        initialEndDate: PropTypes.any,
        initialStartDate: PropTypes.any,
        isActionLoading: PropTypes.bool,
        isColumnsLoaded: PropTypes.bool,
        isColumnsLoading: PropTypes.bool,
        isDataLoading: PropTypes.bool,
        isDataLoadingSelector: PropTypes.func.isRequired,
        isExportMessageVisible: PropTypes.bool,
        isMerchantsLoaded: PropTypes.bool,
        itemKey: PropTypes.string.isRequired,
        ListItemComponent: PropTypes.func.isRequired,
        merchantIdKey: PropTypes.string,
        merchantMap: PropTypes.any,
        needsRefetch: PropTypes.bool,
        noDataText: PropTypes.string.isRequired,
        onColumnsChange: PropTypes.func.isRequired,
        onDoAction: PropTypes.func,
        onBulkAction: PropTypes.func,
        onFetchData: PropTypes.func.isRequired,
        onGetColumnSettings: PropTypes.func.isRequired,
        onGetCsv: PropTypes.func,
        onUnmount: PropTypes.func.isRequired,
        pages: PropTypes.number,
        pagesSelector: PropTypes.func,
        resetNeedsRefetch: PropTypes.func,
        onDataFetched: PropTypes.func,
        selectedMerchantIds: PropTypes.string,
        selectRow: PropTypes.func,
        setExportType: PropTypes.func,
        shouldAddRefreshButton: PropTypes.bool,
        shouldUseAllMerchants: PropTypes.bool,
        shouldUseGlobalDate: PropTypes.bool,
        shouldAddCheckboxColumn: PropTypes.bool,
        shouldHideCardPadding: PropTypes.bool,
        shouldHideDateRange: PropTypes.bool,
        shouldHideExport: PropTypes.bool,
        shouldRowBeCheckable: PropTypes.func,
        shouldUseProvidedMerchantName: PropTypes.bool,
        sorts: PropTypes.array,
        SubComponent: PropTypes.func,
        toggleExportMessageVisible: PropTypes.func,
        uniqueTableName: PropTypes.string.isRequired,
        alternatePicker: PropTypes.string,
        timezone: PropTypes.string,
        customAccess: PropTypes.any,
        footerText: PropTypes.string,
        hidePageSizeSelect: PropTypes.bool
    };

    static defaultProps = {
        bulkActions: [],
        columns: [],
        count: 0,
        data: [],
        hasMore: false,
        hasNoCount: false,
        isColumnsLoading: false,
        isDataLoading: false,
        isActionLoading: false,
        pages: 0,
        filterable: false,
        shouldAddRefreshButton: true,
        shouldUseProvidedMerchantName: false
    };

    constructor(props) {
        super(props);

        this.handleUpdateQuery = this.handleUpdateQuery.bind(this);
        this.handleSelectRow = this.handleSelectRow.bind(this);
        this.addMerchantNamesToData = this.addMerchantNamesToData.bind(this);
        this.handleResetNeedsRefetch = this.handleResetNeedsRefetch.bind(this);

        let initialStartDate, initialEndDate;

        if (this.props.globalDateRange && this.props.shouldUseGlobalDate) {
            initialStartDate = this.props.globalDateRange.startDate;
            initialEndDate = this.props.globalDateRange.endDate;
        } else if (this.props.timezone) {
            initialStartDate = props.initialStartDate ? props.initialStartDate : moment().tz(props.timezone).startOf('day').add(-1, 'month');
            initialEndDate = props.initialEndDate ? props.initialEndDate : moment().tz(props.timezone).endOf('day');
        } else if (this.props.alternatePicker === 'month') {
            initialStartDate = moment().startOf('month').add(-2, 'month');
        } else {
            initialStartDate = moment().utc().startOf('day').add(-1, 'month');
            initialEndDate = moment().utc().endOf('day');
        }

        this.state = {
            initialEndDate,
            initialStartDate,
            needsPageReset: false,
            needsRefetch: false
        };
    }

    componentDidMount() {
        this.props.onGetColumnSettings();
        mixpanel.track(`${this.props.uniqueTableName} mounted`);
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props);
        toastIfError(prevProps, this.props, 'columnsError');
        toastIfError(prevProps, this.props, 'csvError');

        const wereColumnsChangedByAUser = doesPropExistAndHasItChanged(prevProps, this.props, 'columns') && !(prevProps.isColumnsLoading && !this.props.isColumnsLoading);

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'selectedMerchantIds') && this.props.isMerchantsLoaded) {
            this.setState({ needsPageReset: true });

            if (this.props.resetNeedsRefetch) {
                this.props.resetNeedsRefetch();
            }
        } else if (
            ((doesPropExistAndHasItChanged(prevProps, this.props, 'needsRefetch') && this.props.needsRefetch === true) || wereColumnsChangedByAUser) &&
            this.props.isMerchantsLoaded
        ) {
            this.setState({ needsRefetch: true });

            if (this.props.resetNeedsRefetch) {
                this.props.resetNeedsRefetch();
            }
        }

        // Trigger silent widget refresh when table data finishes loading
        // Only trigger if data was actually fetched (not initial mount)
        if (
            this.props.onDataFetched &&
            prevProps.isDataLoading === true &&
            this.props.isDataLoading === false &&
            prevProps.data !== undefined // Only if we had previous data (not initial load)
        ) {
            // Trigger silent refresh of widget when table data is fetched after filters/sorts change
            this.props.onDataFetched();
        }
    }

    handleUpdateQuery(queryString) {
        const preservedQueryString = preserveQueryParams(
            this.props.history.location.search,
            queryString
        );
        this.props.history.replace(
            `${this.props.history.location.pathname}${preservedQueryString}`
        );
    }

    handleSelectRow(row, newTab) {
        if (this.props.selectRow) {
            this.props.selectRow(this.props.history, row, newTab);
        }
    }

    addMerchantNamesToData(data, merchantMap, merchantIdKey = 'merchantId') {
        if (this.props.shouldUseProvidedMerchantName) {
            return data;
        } else {
            return data.map((item) => {
                const merchantId = get(item, merchantIdKey);

                item.merchantName = merchantMap[merchantId];

                return item;
            });
        }
    }

    handleResetNeedsRefetch() {
        this.setState({ needsRefetch: false });
        this.setState({ needsPageReset: false });
    }

    render() {
        const withMerchants = this.addMerchantNamesToData(this.props.data, this.props.merchantMap, this.props.merchantIdKey);
        let csvDataWithMerchants;
        if (this.props.csvData) {
            csvDataWithMerchants = this.addMerchantNamesToData(this.props.csvData, this.props.merchantMap, this.props.merchantIdKey);
        }

        let bulkActionsWithDispatch;

        if (this.props.bulkActions.length) {
            bulkActionsWithDispatch = map(this.props.bulkActions, (bulkAction) => {
                return {
                    ...bulkAction,
                    onClick: (checkedRows) => this.props.onBulkAction(bulkAction.onClick, checkedRows)
                };
            });
        }

        let shouldHideExport = this.props.shouldHideExport;
        if (this.props.customAccess) {
            shouldHideExport = !doesRoleHaveAccessToFeature(this.props.customAccess, {
                [config.serviceArns.exports]: ['GET/v3/getExports']
            });
        }

        return (
            <div className="table-wrapper">
                <EmvioRow>
                    <EmvioCard className={classNames('grow-height', {
                        'no-card-padding': this.props.shouldHideCardPadding
                    })}>
                        <EmvioTable
                            appElement="#root"
                            bulkActions={bulkActionsWithDispatch}
                            className={this.props.className}
                            clickShouldExpandRow={this.props.clickShouldExpandRow}
                            columns={this.props.columns}
                            columnsToNotClick={this.props.columnsToNotClick}
                            count={this.props.count}
                            csvData={csvDataWithMerchants}
                            csvLoading={this.props.csvLoading}
                            data={withMerchants}
                            dateKey={this.props.dateKey}
                            defaultColumnsAndProps={this.props.defaultColumnsAndProps}
                            defaultFiltered={this.props.defaultFiltered}
                            defaultPageSize={this.props.defaultPageSize}
                            defaultSorted={this.props.sorts ? this.props.sorts : this.props.defaultSorted}
                            exportButtonMessage={this.props.exportButtonMessage}
                            filterable={this.props.filterable}
                            getTableState={this.props.getTableState ? this.props.getTableState : noop}
                            hasMore={this.props.hasMore}
                            hasNoCount={this.props.hasNoCount}
                            HeaderComponent={this.props.HeaderComponent}
                            initialEndDate={this.state.initialEndDate}
                            initialStartDate={this.state.initialStartDate}
                            isDataLoading={this.props.isDataLoading || this.props.isActionLoading}
                            isExportMessageVisible={this.props.isExportMessageVisible}
                            isTableLoading={this.props.isColumnsLoading || !this.props.isColumnsLoaded || !this.props.isMerchantsLoaded}
                            itemKey={this.props.itemKey}
                            ListItemComponent={this.props.ListItemComponent}
                            needsPageReset={this.state.needsPageReset}
                            needsRefetch={this.state.needsRefetch}
                            noDataText={this.props.noDataText}
                            onColumnsChange={this.props.onColumnsChange}
                            onFetchCsv={!shouldHideExport ? this.props.onGetCsv(this.props.selectedMerchantIds, this.props.columns) : undefined}
                            onFetchData={this.props.shouldUseAllMerchants ? this.props.onFetchData(this.props.allMerchantIdsString, this.props.columns) : this.props.onFetchData(this.props.selectedMerchantIds, this.props.columns)}
                            onGoToItem={this.handleSelectRow}
                            onUpdateQuery={this.handleUpdateQuery}
                            pages={this.props.pages}
                            queryStringURL={this.props.history.location.search}
                            resetNeedsRefetch={this.handleResetNeedsRefetch}
                            shouldAddRefreshButton={this.props.shouldAddRefreshButton}
                            shouldAddCheckboxColumn={this.props.shouldAddCheckboxColumn}
                            shouldAddColumnDialog
                            shouldHideDateRange={this.props.shouldHideDateRange}
                            shouldRowBeCheckable={this.props.shouldRowBeCheckable}
                            SubComponent={this.props.SubComponent}
                            toggleExportMessageVisible={this.props.toggleExportMessageVisible}
                            uniqueTableName={this.props.uniqueTableName}
                            alternatePicker={this.props.alternatePicker}
                            timezone={this.props.timezone}
                            hidePageSizeSelect={this.props.hidePageSizeSelect}
                            setExportType={this.props.setExportType}
                        />
                        <div className="table-footer">
                            <small className="footer-text">{this.props.footerText}</small>
                        </div>
                    </EmvioCard>
                </EmvioRow>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        columns: getColumnsByUniqueTableName(state, ownProps.uniqueTableName),
        columnsError: getColumnsErrorMessageByUniqueTableName(state, ownProps.uniqueTableName),
        count: ownProps.countSelector ? ownProps.countSelector(state) : ownProps.count,
        csvData: getCsvData(state),
        csvError: getCsvErrorMessage(state),
        csvLoading: getIsCsvLoading(state),
        data: ownProps.dataSelector(state),
        error: ownProps.errorMessageSelector(state),
        globalDateRange: getDateRange(state),
        hasMore: ownProps.hasMoreSelector ? ownProps.hasMoreSelector(state) : ownProps.hasMore,
        isColumnsLoaded: getIsColumnsLoadedByUniqueTableName(state, ownProps.uniqueTableName),
        isColumnsLoading: getIsColumnsLoadingByUniqueTableName(state, ownProps.uniqueTableName),
        isDataLoading: ownProps.isDataLoadingSelector(state),
        isMerchantsLoaded: getIsMerchantsLoaded(state),
        merchantMap: getMerchantsMapper(state),
        pages: ownProps.pagesSelector(state),
        allMerchantIdsString: getMerchantIdsString(state),
        selectedMerchantIds: getSelectedMerchantIdsString(state),
        sorts: getSortsByUniqueTableName(state, ownProps.uniqueTableName),
        customAccess: getCustomAccess(state)
    };
}

const debouncedFetch = debounce((fetchData, dispatch, filters, page, pageSize, sorters, merchantIds, columns) => {
    dispatch(fetchData(filters, page, pageSize, sorters, merchantIds, columns));
}, 500);

const debouncedUpdateUserSettings = debounce((updateColumnsSettings, dispatch, uniqueTableName, columns, sorters) => {
    dispatch(updateColumnsSettings(uniqueTableName, columns, sorters));
}, 300);

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onBulkAction: (bulkActionFunction, checkedRows) => dispatch(bulkActionFunction(checkedRows)),
        onColumnsChange: (sorters, columns) => debouncedUpdateUserSettings(updateColumnsSettings, dispatch, ownProps.uniqueTableName, columns, sorters),
        onFetchData: (merchantIds, columns) => (filters, page, pageSize, sorters) => {
            const dateRangeFilter = find(filters, ['id', ownProps.dateKey]);
            const dateRange = get(dateRangeFilter, 'value');

            if (dateRange && ownProps.shouldUseGlobalDate) {
                dispatch(updateDateRange(dateRange));
            }
            debouncedFetch(ownProps.fetchData, dispatch, filters, page, pageSize, sorters, merchantIds, columns);
        },
        onGetColumnSettings: () => dispatch(getColumnsSettings(ownProps.uniqueTableName, ownProps.defaultColumnsAndProps)),
        onGetCsv: (merchantIds, columns) => (filters, sorts, dateKey) => dispatch(getCSV(ownProps.fetchUrl, merchantIds, columns, filters, sorts, dateKey, ownProps.uniqueTableName)),
        onUnmount: () => dispatch(onUnmount())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Table));
